import type { ApiRes, ApiClientType, ApiBaseUrlType, HeadersOptionType } from '@/uTypes/api'
import type { InsuranceCheckoutData } from '@/uTypes/order/insurance'

export interface GetAllContractInsuranceResult {
  orderGroupId: string
  productName: string
  contractState: string
  destinationCountryName: string | null
  destinationCountryCode: string | null
  destinationCountryCodeUrl: string | null
  planName: string | null
  contractorName: string | null
  insuredCount: number
  insuranceStartDateTime: string
  insuranceEndDateTime: string
  paidAt: string
  policyNo: string | null
  canceledAt: string
}

// export interface getMyInsuranceContract
export const useInsuranceAPI = () => {
  const nuxtApp = useNuxtApp()
  const getApiClient = (
    nuxtApp.$api as {
      getApiClient: (
        apiBaseUrlType?: ApiBaseUrlType,
        headersOption?: HeadersOptionType
      ) => ApiClientType
    }
  ).getApiClient
  const $api = getApiClient()
  const $apiV3 = getApiClient('v3')

  const getAllContractInsurance = (): Promise<ApiRes<GetAllContractInsuranceResult>> => {
    return $api.get('/travel-insurance/contracts')
  }

  const getMyInsuranceContract = (orderGroupId: string): Promise<ApiRes<any>> => {
    return $api.get(`/travel-insurance/contracts/${orderGroupId}`)
  }

  const cancelContract = (orderGroupId: string): Promise<ApiRes<AirportTaxiReservation>> => {
    return $apiV3.post(`/orders/group/cancel/${orderGroupId}`)
  }

  /**
   * 결제 페이지 체크아웃 요약 — 스테이징한 본인만. 만료/삭제 시 410.
   * 기존 `insurance_payment_view` 쿠키를 대체한다.
   */
  const getInsuranceCheckout = (
    orderGroupId: string
  ): Promise<ApiRes<InsuranceCheckoutData>> => {
    return $apiV3.get(`/orders/group/insurance/${orderGroupId}/checkout`)
  }

  return {
    getAllContractInsurance,
    getMyInsuranceContract,
    cancelContract,
    getInsuranceCheckout
  }
}
